module.exports = __webpack_public_path__ + "static/tasklistMa-7c6b617f4d4a46afc7c85583d57c0ce3.jpg";